module.exports = __webpack_public_path__ + "img/AvatarEliteGladiator.6535315f.svg";